import React, { useCallback, useState } from "react";
import { GoogleReCaptcha, useGoogleReCaptcha } from "react-google-recaptcha-v3";

const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

const ReCaptcha = () => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const [token, setToken] = useState(null);

  const onVerify = useCallback(async (token) => {
    try {
      setToken(token);
      // console.log("Verified recaptcha token:", token);
    } catch (error) {
      console.log("Error during reCAPTCHA verification:", error);
    }
  }, []);

  // You can call this function when you need to explicitly trigger reCAPTCHA
  const handleReCaptchaVerify = useCallback(async () => {
    try {
      if (!executeRecaptcha) {
        console.log("Execute recaptcha not yet available");
        return;
      }

      const token = await executeRecaptcha("homepage");
      onVerify(token);
    } catch (error) {
      console.log("Error during reCAPTCHA verification:", error);
    }
  }, [executeRecaptcha, onVerify]);

  return (
    <>
      <GoogleReCaptcha onVerify={onVerify} />
    </>
  );
};

export default ReCaptcha;
